<template>
    <div class="module-overlay module-overlay--default" :class="{'-open': cartStore.overlay, '-loading': cartStore.loading}">
        <div class="overlay__overlay">
            <div class="overlay__bg" @click="handleCloseOverlay()"></div>
            <div class="overlay__content">
                <div class="overlay__close" @click="handleCloseOverlay()"></div>
                <div class="content-wrapper" v-if="cartStore.submitted">
                    <div class="overlay__headline">
                        <span class="heading beta -color-text-alpha" v-if="cartStore.success">{{ $t('overlay.headlineSuccess') }}</span>
                        <span class="heading beta -color-text-alpha" v-else>{{ $t('overlay.headlineError') }}</span>
                    </div>
                    <div class="content__content">
                        <p v-if="!cartStore.success">{{ $t('overlay.textError') }}</p>
                    </div>
                </div>
                <div class="content-wrapper" v-else-if="!cartStore.enabledForm">
                    <div class="overlay__headline">
                        <span class="heading beta -color-text-alpha">{{ $t('overlay.headline') }}</span>
                        <p v-if="cartStore.removeHint">{{ $t('overlay.removehint') }}</p>
                    </div>
                    <div class="content__content form" :class="{'-overflow': cartStore.items.length > 3 && !showAll}">
                        <div class="remove-all-lnk link" @click="cartStore.removeAll()">
                            <span class="icon-times-before">{{ $t('list.removeAllFromCart') }}</span>
                        </div>
                        <div class="overlay__items" v-if="cartStore.items.length">
                            <template v-for="(item, key) in cartStore.items" :key="key">
                                <div class="item__item">
                                    <div class="item__main">
                                        <router-link :to="{name: 'Detail', query: {cableLength: item.cableConfigLength}, params: {id: item.id}}" class="item__image" replace>
                                            <img :src="partsStore.imagePath + '/' + item.image" alt="part image" v-if="item.image">
                                            <img src="../assets/partnumbersearch-placeholder-products.jpg" height="90" width="119"
                                                 alt="part image" v-else/>
                                            <div class="image__meta">
                                                <span class="meta__meta">{{ item.type }}</span>
                                            </div>
                                        </router-link>
                                        <div class="item__content">
                                            <div class="content__meta">
                                                <router-link :to="{name: 'Detail', query: {cableLength: item.cableConfigLength}, params: {id: item.id}}" class="meta__id">
                                                    <span class="item-id bold meta -color-alpha" v-if="item.cableConfigLength && !item.hidePartNo">{{ item.id + globalStore.fillUpLength(item.cableConfigLength) }}</span>
                                                    <span class="item-id bold meta -color-alpha" v-else-if="!item.hidePartNo">{{ item.id }}</span>
                                                    <img src="../assets/express.jpeg" height="23" width="100" alt="express" v-if="item.express"/>
                                                </router-link>
                                                <div class="meta__link" @click="cartStore.removeFromCart(item, key)" v-if="cartStore.itemInCart(item)">
                                                    <span class="bold meta -color-text-alpha icon-times-before">{{ $t('list.removeFromCart') }}</span>
                                                </div>
                                            </div>
                                            <div class="content__description">
                                                <div class="description__description">
                                                    <router-link :to="{name: 'Detail', query: {cableLength: item.cableConfigLength}, params: {id: item.id}}" class="heading espilon -color-text-alpha">{{ item.description }}</router-link>
                                                    <CheckboxField
                                                            v-if="item.freeSample"
                                                            :identifier="'sample-checkbox-' + key"
                                                            :label="'Free sample'"
                                                            @update:modelValue="newValue => {cartStore.sampleArr = newValue}"
                                                            @handleTracking="newValue => handleTracking(item.id, newValue)"
                                                            :value="{searchTerm: item.id, value: item.id}"
                                                            :modelValue="cartStore.sampleArr"
                                                    ></CheckboxField>
                                                </div>
                                            </div>
                                        </div>
                                        <div @click="handleCableconfiHint(item.id)" class="item__cableconfi-hint" v-if="item.cableConfigurationAvailable">
                                            <div class="cableconfi-hint">
                                                <span>{{ $t('overlay.cableconfihint') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="item__bottom" v-if="item.cableConfigLength">
                                        <div class="bottom__filter">
                                            <div class="item__filter">
                                                <span class="bold -color-text-alpha meta">{{ $t('show.cableconfi.bend.label') }} {{ item.cableConfigBend }}</span>
                                            </div>
                                            <div class="item__filter">
                                                <span class="bold -color-text-alpha meta">{{ $t('show.cableconfi.cableType.label') }} {{ item.cableConfigCountNo }}</span>
                                            </div>
                                            <div class="item__filter">
                                                <span class="bold -color-text-alpha meta">{{ $t('show.cableconfi.cableLength.label') }} {{ item.cableConfigLength }} mm</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="overlay__items" v-else>
                            <span>{{ $t('overlay.noItems') }}</span>
                        </div>
                    </div>
                    <div class="overlay__show-all-btn -centered" v-if="cartStore.items.length > 3 && !showAll">
                        <div class="link" @click="showAll = true">
                            <span>{{ $t('overlay.showAll') }}</span>
                        </div>
                    </div>
                    <div class="overlay__cta">
                        <div class="btn -btn-alpha" @click="cartStore.enabledForm = true">
                            <span>{{ $t('overlay.inquirybtn') }}</span>
                        </div>
                        <a :href="'mailto:?subject=ODU Product Finder notepad&body=Take a look at what I found at the ODU Product Finder:%0D%0A%0D%0A' + cartStore.productString" class="btn -btn-alpha">
                            <span>{{ $t('overlay.sharebtn') }}</span>
                        </a>
                        <router-link to="/" class="btn -btn-alpha" @click="handleCloseOverlay()">
                            <span>{{ $t('overlay.backbtn') }}</span>
                        </router-link>
                    </div>
                </div>
                <div class="content-wrapper" v-else-if="cartStore.enabledForm">
                    <div class="overlay__headline">
                        <span class="backlink icon-angle-left-before -color-alpha" @click="cartStore.enabledForm = false">{{ $t('overlay.back') }}</span>
                        <span class="heading beta -color-text-alpha">{{ $t('overlay.headline') }}</span>
                    </div>
                    <form class="form overlay__items" id="inquiryRequest" @submit.prevent="onSubmitForm" ref="form">
                        <div class="module-hint" v-if="!cartStore.items.length">
                            <span class="icon-tooltip-before">{{ $t('overlay.hint') }}</span>
                        </div>
                        <div class="page__wrap">
                            <div class="field__wrap l-2col-b1-50-50">
                                <div class="col col-one selectbox">
                                    <SelectboxField
                                            :required="false"
                                            identifier="salutation"
                                            :label="$t('overlay.form.salutation')"
                                            v-model="cartStore.form.salutation"
                                            :value="cartStore.form.salutation"
                                            :options="[
                          {value: 'Mr', label: $t('overlay.form.mr')},
                          {value: 'Mrs', label: $t('overlay.form.mrs')},
                          {value: 'Prefer not to say', label: $t('overlay.form.preferNotToSay')}
                      ]"
                                    ></SelectboxField>
                                </div>
                            </div>
                            <div class="field__wrap l-2col-b1-50-50">
                                <div class="col col-one">
                                    <InputField
                                            :required="false"
                                            identifier="firstname"
                                            :label="$t('overlay.form.firstname')"
                                            v-model="cartStore.form.firstname"
                                            :value="cartStore.form.firstname"
                                    ></InputField>
                                </div>
                                <div class="col col-two">
                                    <InputField
                                            :required="false"
                                            identifier="lastname"
                                            :label="$t('overlay.form.lastname')"
                                            v-model="cartStore.form.lastname"
                                            :value="cartStore.form.lastname"
                                    ></InputField>
                                </div>
                            </div>
                            <div class="field__wrap l-2col-b1-50-50">
                                <div class="col col-one">
                                    <InputField
                                            :required="false"
                                            identifier="company"
                                            :label="$t('overlay.form.company')"
                                            v-model="cartStore.form.company"
                                            :value="cartStore.form.company"
                                    ></InputField>
                                </div>
                                <div class="col col-two">
                                    <CountrySearch
                                            :required="true"
                                            identifier="country"
                                            :label="$t('overlay.form.required.country')"
                                            @prediction-selected="cartStore.form.country = $event"
                                    ></CountrySearch>
                                </div>
                            </div>
                            <div class="field__wrap l-1col">
                                <div class="col">
                                    <InputField
                                            :required="false"
                                            identifier="address"
                                            :label="$t('overlay.form.address')"
                                            v-model="cartStore.form.address"
                                            :value="cartStore.form.address"
                                    ></InputField>
                                </div>
                            </div>
                            <div class="field__wrap l-2col-b1-25-75">
                                <div class="col col-one">
                                    <InputField
                                            :required="false"
                                            identifier="zip"
                                            :label="$t('overlay.form.zip')"
                                            v-model="cartStore.form.zip"
                                            :value="cartStore.form.zip"
                                    ></InputField>
                                </div>
                                <div class="col col-two">
                                    <InputField
                                            :required="false"
                                            identifier="city"
                                            :label="$t('overlay.form.city')"
                                            v-model="cartStore.form.city"
                                            :value="cartStore.form.city"
                                    ></InputField>
                                </div>
                            </div>
                            <div class="field__wrap l-1col">
                                <div class="col">
                                    <InputField
                                            :required="false"
                                            identifier="phone"
                                            :label="$t('overlay.form.phone')"
                                            v-model="cartStore.form.phone"
                                            :value="cartStore.form.phone"
                                    ></InputField>
                                </div>
                            </div>
                            <div class="field__wrap l-1col">
                                <div class="col">
                                    <InputField
                                            :required="true"
                                            identifier="email"
                                            :label="$t('overlay.form.email')"
                                            v-model="cartStore.form.email"
                                            :value="cartStore.form.email"
                                    ></InputField>
                                </div>
                            </div>
                            <div class="field__wrap l-1col">
                                <div class="col">
                                    <TextareaField
                                            :required="false"
                                            identifier="message"
                                            :label="$t('overlay.form.message')"
                                            v-model="cartStore.form.message"
                                            :value="cartStore.form.message"
                                    ></TextareaField>
                                </div>
                            </div>
                            <div class="field__wrap l-1col">
                                <div class="col">
                                    <PrivacyCheckboxField
                                            identifier="privacy"
                                            @update:modelValue="newVal => cartStore.form.privacy = newVal"
                                            v-model="cartStore.form.privacy"
                                            :value="cartStore.form.privacy"
                                    >
                                    </PrivacyCheckboxField>
                                </div>
                            </div>
                            <button class="btn -btn-alpha" type="submit">
                                <span>{{ $t('overlay.form.send') }}</span>
                            </button>
                            <div v-html="recaptchaInfo"></div>
                        </div>
                    </form>
                    <div class="loading-overlay">
                        <div class="lds-dual-ring"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useCartStore } from '@/stores/cart'
import { usePartsStore } from '@/stores/parts'
import { ref, watch } from 'vue'
import CheckboxField from '@/components/form/CheckboxField'
import PrivacyCheckboxField from '@/components/form/PrivacyCheckboxField'
import SelectboxField from '@/components/form/SelectboxField'
import InputField from '@/components/form/InputField'
import TextareaField from '@/components/form/TextareaField'
import { useGlobalStore } from '@/stores'
import { useCableConfiguratorStore } from '@/stores/cableConfigurator'
import { useRouter } from 'vue-router'
import CountrySearch from '@/components/form/CountrySearch.vue'

const recaptchaInfo = window.app.partnumber_search_extended.recaptcha_info

const cartStore = useCartStore()
const partsStore = usePartsStore()
const globalStore = useGlobalStore()
const cableCableConfiguratorStore = useCableConfiguratorStore()
const router = useRouter()

const showAll = ref(false)

watch(() => cartStore.overlay, () =>
{
    if (cartStore.overlay)
    {
        let html = document.getElementsByTagName('html')
        html[0].classList.add('-no-scroll')
    }
    else
    {
        let html = document.getElementsByTagName('html')
        html[0].classList.remove('-no-scroll')
        cartStore.removeHint = false
    }
})

function onSubmitForm ()
{
    cartStore.submitForm()
}

function handleTracking (id, newValue)
{
    if (!newValue.value)
    {
        if (window.dataLayer)
        {
            window.dataLayer.push({
                'free-sample': id,
                'event': 'free-sample-event'
            })
        }
    }
}

function handleCableconfiHint (id)
{
    cableCableConfiguratorStore.scrollToCableConfi = true
    cartStore.overlay = false
    router.push({
        path: '/show/' + id
    })
}

function handleCloseOverlay ()
{
    if (cartStore.enabledForm)
    {
        if (window.dataLayer)
        {
            window.dataLayer.push({
                'productfinder-request-canceled': cartStore.items.map(el => el.id)
                    .toString(),
                'event': 'productfinder-request-canceled-event'
            })
        }
    }
    cartStore.overlay = false
}
</script>
